import { useState } from 'react';

// Simple module-level state for dialog
let dialogState = false;
let dialogListeners: Array<(state: boolean) => void> = [];

export function useDialog() {
	const [show, setShow] = useState(dialogState);

	const setShowDialog = (newState: boolean) => {
		dialogState = newState;
		dialogListeners.forEach(listener => listener(newState));
	};

	// Subscribe to changes
	useState(() => {
		const listener = (newState: boolean) => setShow(newState);
		dialogListeners.push(listener);
		return () => {
			dialogListeners = dialogListeners.filter(l => l !== listener);
		};
	});

	return { show, setShowDialog };
}
